import config from '../../config/App_data';
import GetData from '../../RestAPI/getDataService';

const getChaptersWithPremiumAndFreeCount = async data => {
  return await GetData.callAPI(
    `${config.backend_api}/exams/cfa/question-bank/chapter-wise-count`,
    data,
  );
};
const fetchLastAnsweredQuestion = async (data = {}) => {
  return await GetData.callAPI(
    `${config.backend_api}/exams/cfa/question-bank/last-answered-question`,
    data,
  );
};
module.exports = {
  getChaptersWithPremiumAndFreeCount,
  fetchLastAnsweredQuestion,
};



// WEBPACK FOOTER //
// ./src/views/CFA1-2025/QuestionBank/ApiService.js